// extracted by css-extract-rspack-plugin
export default {"gap8":"DashboardEditViewActions-module__gap8__jmAkB"};